/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-23 18:47:49
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import CrcConfigApi, {CrcConfigDOI} from './api/crcConfigApi'

export namespace CrcConfigVOI {
   export interface PropsI {
       operate: string;
       id?: number;

       saveSuccess?(): void;

       cancel?(): void;
   }

   export interface FormDataI {
        crc: string;
        file_name: string;
   }
}

@Component
class CrcConfigModal extends Vue.Component<CrcConfigVOI.PropsI> {
   @Prop({
       type: Function,
   })
   cancel!: () => void;

   @Prop({
       type: Number,
   })
   id!: number;

   @Prop({
       type: String,
   })
   operate!: string;

   @Prop({
       type: Function,
   })
   saveSuccess!: () => void;

   visible: boolean = false;

   loading: boolean = false;

   formData: CrcConfigVOI.FormDataI = {
        crc: '',
        file_name: '',
   };
   rules: any = {};

   close() {
       this.cancel && this.cancel();
       this.closeModal();
   }

   closeModal() {
       this.visible = false;
       this.$emit('close', false);
   }

   async save() {
       if (!(await this.$validate('formValidate'))) {
           return;
       }
       let res;
       this.loading = true;
       let params: CrcConfigDOI.FormDataI = {
           ...this.formData,
       };
       res = await CrcConfigApi.add(params);
       this.loading = false;
       let { code } = res;
       if (code === 0) {
           Toast.success('成功');
           this.saveSuccess();
           this.closeModal();
       }
   }

   
   render(h) {
       return (
           <Modal title={this.operate+"crc"} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
               <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                   <form-item required  label="crc" prop="crc" style="display: inline-block;width:45%">
                       <Input  placeholder="请输入" v-model={this.formData.crc} />
                   </form-item>
                   <form-item required  label="文件名" prop="file_name" style="display: inline-block;width:45%">
                       <Input  placeholder="请输入" v-model={this.formData.file_name} />
                   </form-item>
               </i-form>
               <div slot="footer">
                   <Button type="primary" ghost on-click={this.close}>
                       取消
                   </Button>
                   <Button type="primary" on-click={this.save} loading={this.loading}>
                       保存
                   </Button>
               </div>
           </Modal>
       );
   }
}

export default function alertCrcConfigModal(operate: string, id?: number): Promise<boolean> {
   return new Promise((resolve, reject) => {
       modalFactory<CrcConfigVOI.PropsI>(CrcConfigModal)({
           id,
           operate,
           saveSuccess() {
               resolve(true);
           },
           cancel() {
               resolve(false);
           },
       });
   });
}